// extracted by mini-css-extract-plugin
export default {"galleryPage":"GalleryPage_galleryPage__QR4Uh"};